import React from "react";
import { useSelector } from "react-redux";
import { Toaster } from "../Toaster";
import { RootReduxState } from "~/modules/app/components/ReduxProvider/types";
import { useToaster } from "../../hooks/useToaster";

// // // //

/**
 * ToasterLayout
 * Renders a layout for displaying toasts
 */
export function ToasterLayout() {
    const { toasters } = useSelector((state: RootReduxState) => state.toaster);
    const { removeToaster } = useToaster();

    if (toasters.length === 0) {
        return null;
    }

    return (
        <div className="fixed bottom-20 right-4 z-100">
            <div className="flex flex-col justify-end items-end gap-4">
                {toasters.map((t) => (
                    <Toaster
                        key={t.id}
                        variant={t.variant}
                        message={t.message}
                        duration={t.duration}
                        onRemove={() => {
                            removeToaster({ id: t.id });
                        }}
                    />
                ))}
            </div>
        </div>
    );
}
